module.exports = __webpack_public_path__ + "media/icons/edit_document-3681e408.svg";